import React, {Component} from 'react'
import ListItemsPage from "./ListItemsPage"

class ListItemsContainer extends Component {
    render() {
        return (
            <div className="ListItemsContainer">
                <ListItemsPage {...this.props}/>
            </div>
        )
    }
}

export default ListItemsContainer
